import { Banner } from '@workspace/ui/components/banner'
import { Button } from '@workspace/ui/components/button'
import { ProfileSection } from '@workspace/ui/components/profile-section'
import { AlertTriangle, Link2Off } from 'lucide-react'
import { useState } from 'react'

interface DangerZoneBannerProps {
  title: string
  description: string
  actionLabel: string
  pendingLabel: string
  onConfirm: () => void
  isPending: boolean
}

export function DangerZoneBanner({
  title,
  description,
  actionLabel,
  pendingLabel,
  onConfirm,
  isPending,
}: DangerZoneBannerProps) {
  const [confirmState, setConfirmState] = useState(false)

  return (
    <ProfileSection title="Danger Zone">
      <Banner
        variant="danger"
        icon={<Link2Off className="size-4.5" />}
        title={title}
        description={description}
        actions={
          confirmState ? (
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setConfirmState(false)}
                disabled={isPending}
              >
                Cancel
              </Button>
              <Button variant="destructive" size="sm" onClick={onConfirm} disabled={isPending}>
                <AlertTriangle className="size-3.5" />
                {isPending ? pendingLabel : 'Confirm'}
              </Button>
            </div>
          ) : (
            <Button
              variant="outline"
              size="sm"
              onClick={() => setConfirmState(true)}
              className="border-red-500/20 text-red-400 hover:bg-red-500/10 hover:text-red-400"
            >
              {actionLabel}
            </Button>
          )
        }
      />
    </ProfileSection>
  )
}
